export const ROUTES = {
  home: '/',
  notFound: '/404',
};
